import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FaArrowRight } from 'react-icons/fa';

const NotFound = () => (
  <main className="not-found" aria-labelledby="not-found-title">
    <Helmet>
      <title>Page Not Found | Media Mars</title>
      <meta name="description" content="The page you are looking for could not be found on the Media Mars website." />
      <meta name="robots" content="noindex" />
      <link rel="canonical" href="https://www.media-mars.com/404" />
    </Helmet>
    <div className="not-found__inner">
      <span className="not-found__eyebrow">404</span>
      <h1 id="not-found-title">Page not found</h1>
      <p>The page you are looking for may have moved, or the address may be incorrect.</p>
      <div className="not-found__actions">
        <Link to="/" className="btn-primary">Back to Home <FaArrowRight /></Link>
        <Link to="/services" className="btn-secondary">View Solutions</Link>
        <Link to="/contact" className="btn-secondary">Contact Us</Link>
      </div>
    </div>
  </main>
);

export default NotFound;
